/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * A milestone that contributes toward completion of the catalog task.
 * @export
 * @interface Milestone
 */
export interface Milestone {
    /**
     * Identifier chosen by the game server for the milestone.
     * @type {string}
     * @memberof Milestone
     */
    id: string;
    /**
     * Display name shown for this milestone.
     * @type {string}
     * @memberof Milestone
     */
    name: string;
    /**
     * Percentage credited when the milestone is marked complete.
     * @type {number}
     * @memberof Milestone
     */
    percentageContribution: number;
    /**
     * Uploaded assets that should be shown for this milestone.
     * @type {Array<string>}
     * @memberof Milestone
     */
    assetIds?: Array<string>;
}


/**
 * Check if a given object implements the Milestone interface.
 */
export function instanceOfMilestone(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "percentageContribution" in value;
    return isInstance;
}

export function MilestoneFromJSON(json: any): Milestone {
    return MilestoneFromJSONTyped(json, false);
}

export function MilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Milestone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'name': json['name'],
        'percentageContribution': json['percentageContribution'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
    };
}

export function MilestoneToJSON(value?: Milestone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'name': value.name,
        'percentageContribution': value.percentageContribution,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
    };
}

